//Import resources

const Home = () => {
  //RETURN this JSX to UI
  return (
    <div className="container text-center">
      <p>
        Welcome to the <b>Object Detection, Irish Translation Application</b>,
        also known as "ODITA".
      </p>
      <p>
        Click on the 'Scan & Translate' button above to turn on your webcam and
        let it 'detect' any objects it sees. <br />
        Then you can translate the word for that object into Irish and save a
        list of the Irish words you have learned so far.
      </p>
      <br />
      <br />
      <p>
        ODITA is made by{" "}
        <a href="http://paperjuice.ie" target="_blank">
          Paper Juice Creative
        </a>
      </p>
    </div>
  );
};

export default Home;
